/* eslint-disable camelcase,no-console */
import { TelemetryLocation } from "@teaming/common-enums";

// eslint-disable-next-line no-unused-vars
export default ( { currentUser, amplitude, intercom, } ) => {
	return {
		customerPortalLinkClicked() {
			amplitude.event( "Customer Portal Link Clicked", {} );
		},
		paymentConfirmationScreenViewed() {
			amplitude.event( "Payment Confirmation Screen Viewed", {} );
		},
		paymentLinkClicked( { location = TelemetryLocation.SETTINGS, } ) {
			amplitude.event( "Payment Link Clicked", {
				location,
			} );
		},
		userAccountCanceled( { email, reasons = [], comments = "", } ) {
			amplitude.event( "User Account Cancelled", {
				email_address: email,
				reasons: reasons.map( reason => `${ reason }`.trim() ).join( "," ),
				comments,
			} );
		},
		viewedMyActionItems() {
			amplitude.event( "View My Commitments Page", {} );
		},
		viewedMyGoals() {
			amplitude.event( "View My Goals Page", {} );
		},
		viewedUserSettings() {
			amplitude.event( "User Settings Opened", {} );
		},
		viewedUserProfilePage() {
			amplitude.event( "View User's Me Page", {} );
		},
	};
};
